// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

up.compiler('[dropzone-file]', (element) => {
  const input = element.querySelector('input[type="file"]')
  const filename = element.querySelector('[dropzone-file--filename]')

  function onDragOver(event) {
    event.preventDefault()
  }

  function onDrop(event) {
    event.preventDefault()
    input.files = event.dataTransfer.files
    onFilePicked()
  }

  function onFilePicked() {
    updateFilename()
  }

  function updateFilename() {
    const filenames = Array.from(input.files).map(file => file.name)
    filename.innerText = filenames.join(', ')
  }

  input.addEventListener('change', onFilePicked)
  element.addEventListener('drop', onDrop)
  element.addEventListener('dragover', onDragOver)
})
